import { TabContext, TabList, TabPanel } from "@mui/lab"
import { Box, Tab } from "@mui/material"
import React, { useEffect, useState } from "react"
import MetricDetails from "../MetricDetails"
import GroupUserList from "../GroupUserList"
import { StyledTab } from "./Atom"
import { useDispatch, useSelector } from "react-redux"
import { setSelectedBucket } from "../../../../redux/slices/groupProfileSlice"
import GroupDetails from "../GroupDetails"
import { useResponseHandle } from "../../../../hooks"
import AdminAPI from "../../../../../api/admin"
import GroupProfileAPI from "../../../../../api/groupProfile"
import { getTokenLocal } from "../../../../../helper/utils"
import { useNavigate } from "react-router-dom"
import { setOfficeManagersData } from "../../../../../app/redux/slices/usersSlice"
import PracticeList from "../PracticeList"

const adminAPI = new AdminAPI()
const groupProfileAPI = new GroupProfileAPI()
function GroupTabs({ updatePracticeStatus }: any) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [valueTab, setValueTab] = useState("1")
  const groupInfo = useSelector((state: any) => {
    return state.groupProfile.groupInfo
  })
  const allOfficeManagers = useSelector((state: any) => {
    return state.users.officeManagersData
  })

  const handleChangeTab = (
    event: React.SyntheticEvent,
    newValueTab: string,
  ) => {
    setValueTab(newValueTab)
  }

  const tabData = useSelector((state: any) => {
    return state.groupProfile.metricDetailsBuckets
  })

  return (
    <Box
      sx={{
        "& .MuiTabPanel-root": {
          padding: "0px",
        },
        display: "flex",
        // border: "1px solid red",
        height: "100%",
        flexDirection: "column",
      }}
    >
      <TabContext value={valueTab}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            height: "10%",
          }}
        >
          <TabList
            aria-label="Tabs"
            onChange={handleChangeTab}
            TabIndicatorProps={{
              sx: { maxWidth: "34px", height: "4px" },
            }}
          >
            {/* <StyledTab label="Overview" value="1" disableRipple /> */}
            <StyledTab label="Group Users" value="1" disableRipple />
            {/* <StyledTab label="Group User List" value="3" disableRipple /> */}
            <StyledTab
              label="Metrics Details"
              value="2"
              disableRipple
              onClick={() => {
                dispatch(setSelectedBucket(tabData[0]))
              }}
            />
            <StyledTab label="Practices" value="3" disableRipple />
          </TabList>
        </Box>

        {/* <TabPanel value="1">Overview</TabPanel> */}
        <TabPanel value="1" sx={{ flex: 1 }}>
          <GroupDetails />
        </TabPanel>
        {/* <TabPanel value="3">
          <GroupUserList />
        </TabPanel> */}
        <TabPanel value="2" sx={{ flex: 1 }}>
          <MetricDetails />
        </TabPanel>
        <TabPanel value="3" sx={{ flex: 1 }}>
          <PracticeList updatePracticeStatus={updatePracticeStatus} />
        </TabPanel>
      </TabContext>
    </Box>
  )
}
export default GroupTabs
